module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-slider.component.scss
// module id = ./src/app/features/wow-slider/wow-slider.component.scss
// module chunks = main